import React, { useRef, useEffect } from 'react';
import './projectcrousel5.css';

const importAll = (r) => {
    return r.keys().map(r);
};

const images = importAll(require.context('../assets/images/projects/REFRIGERATED VANS', false, /\.(png|jpe?g|svg)$/));

const ProjectCarousel = () => {
    const carouselRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            if (carouselRef.current) {
                const { scrollWidth, clientWidth, scrollLeft } = carouselRef.current;
                const maxScrollLeft = scrollWidth - clientWidth;
                const nextScrollLeft = scrollLeft + clientWidth;

                if (nextScrollLeft > maxScrollLeft) {
                    carouselRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    carouselRef.current.scrollBy({ left: clientWidth, behavior: 'smooth' });
                }
            }
        }, 3000); // Adjust interval as needed (3000 ms = 3 seconds)

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="project-carousel-container" ref={carouselRef}>
            <div className="project-carousel-track">
                {images.map((image, index) => (
                    <div key={index} className="project-carousel-image">
                        <img src={image} alt={`Project ${index + 1}`} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProjectCarousel;
